import { COOKIES } from "@/constants/cookies";
import axios from "axios";
import { parseCookies } from "nookies";

export const apiBackofficeReportsMs = axios.create({
  baseURL: import.meta.env.VITE_BACKOFFICE_REPORTS_MS_API,
  headers: {
    "auth-token": parseCookies()[COOKIES.BACKOFFICE_AUTH],
    Authorization: `Bearer ${parseCookies()[COOKIES.BACKOFFICE_AUTH]}`,
  },
});

apiBackofficeReportsMs.interceptors.request.use((config) => {
  const authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});
